import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import API from 'api';
import { LoginErrorModel, LoginResponseModel, UserLoginViewModel } from 'api/utility/utility.model';

export const useLoginMutation = (
  options: UseMutationOptions<LoginResponseModel, AxiosError<LoginErrorModel>, UserLoginViewModel>
) =>
  useMutation<LoginResponseModel, AxiosError<LoginErrorModel>, UserLoginViewModel>(
    (data) => API.utility.postLogin(data),
    options
  );
